import { atom } from 'jotai';
import { FormSchema_V2, FormField_V2, FieldType_V2 } from '../common/typescript/models/CollectFormV2';

export const FIXED_SYSTEM_FIELD_IDS = ['name', 'description'] as const;

export const isFixedSystemFieldId = (fieldId?: string): boolean => {
  const norm = (fieldId || '').trim().toLowerCase();
  return norm === 'name' || norm === 'description';
};

export const getDefaultFixedFields = (): FormField_V2[] => [
  {
    id: 'name',
    label: 'Tên',
    type: FieldType_V2.TEXT,
    required: true,
    placeholder: 'Nhập tên',
  },
  {
    id: 'description',
    label: 'Mô tả',
    type: FieldType_V2.TEXTAREA,
    required: false,
    placeholder: 'Nhập mô tả',
  },
];

export const ensureFixedSystemFields = (fields: FormField_V2[] = []): FormField_V2[] => {
  const defaults = getDefaultFixedFields();
  const existingMap = new Map<string, FormField_V2>();
  fields.forEach((f) => {
    const norm = (f.id || '').trim().toLowerCase();
    if (norm && !existingMap.has(norm)) {
      existingMap.set(norm, f);
    }
  });

  const fixedRows: FormField_V2[] = defaults.map((def) => {
    const found = existingMap.get(def.id);
    if (found) {
      return {
        ...found,
        id: def.id,
        required: def.id === 'name' ? true : Boolean(found.required),
      };
    }
    return def;
  });

  const customRows = fields.filter((f) => !isFixedSystemFieldId(f.id));
  return [...fixedRows, ...customRows];
};

/**
 * Current form being edited
 */
export const currentFormSchemaAtom = atom<FormSchema_V2>({
  fields: getDefaultFixedFields(),
  metadata: {
    version: '2.0.0',
    createdWith: 'GeoCloudWeb',
  },
});

/**
 * Form metadata (name, description)
 */
export const formMetadataAtom = atom<{
  name: string;
  description: string;
}>({
  name: '',
  description: '',
});

/**
 * Uploaded SQLite files (object names in MinIO)
 */
export const uploadedSqliteFilesAtom = atom<string[]>([]);

/**
 * Currently selected field for editing
 */
export const selectedFieldAtom = atom<FormField_V2 | null>(null);

/**
 * Field configuration drawer visibility
 */
export const fieldConfigDrawerVisibleAtom = atom<boolean>(false);

/**
 * Template UUID (when editing existing template)
 */
export const currentTemplateUuidAtom = atom<string | null>(null);

/**
 * Loading state
 */
export const formBuilderLoadingAtom = atom<boolean>(false);
